<template>
    <div>
        <div class="results">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="alert alert-light text-center">
                Kopā atrasti <strong>{{this.pagination.items_total_count}}</strong> priekšmeti.
            </div>
            <div class="items">
                <a :href="'/item/'+item.id+'/'+item.slug" class="item" v-for="item in items" :key="item.id">
                    <div class="imageWrapper">
                        <div class="imageInner">
                            <img v-if="item.images.length > 0 && item.images[0].file_name" :src="'/public/image/thumb/'+item.images[0].file_name">
                            <img v-else="item.images.length > 0" src="/images/placeholder.jpg">
                        </div>
                    </div>
                    <div class="infoWrapper">
                        <div class="infoContent">
                            <div class="itemNumber">{{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span></div>
                            <div class="itemTitle">{{item.title_old}}</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div class="pagination" v-if="pagination.show_pagination">
            <div class="pages">
                <div class="page" @click="changePage(1)" v-if="pagination.show_first_page">1</div>
                <div class="delimiter" v-if="pagination.show_first_page_divider">...</div>
                <div class="page" @click="changePage(page)" v-for="page in pagination.prev_pages" :key="page">{{page}}</div>
                <div class="page currentPage"  :key="pagination.current_page">{{pagination.current_page}}</div>
                <div class="page" @click="changePage(page)" v-for="page in pagination.next_pages" :key="page">{{page}}</div>
                <div class="delimiter" v-if="pagination.show_last_page_divider">...</div>
                <div class="page" @click="changePage(pagination.total_page_count)" :key="pagination.total_page_count" v-if="pagination.show_last_page">{{pagination.total_page_count}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    mounted()
    {
        var that = this;
        EventBus.$on('search_started', () =>{
            that.loading = true;
        });
        EventBus.$on('items_loaded', data =>{
            that.loading = false;
            that.items = data.items;
            that.pagination = data.pagination;
            that.scrollToTop();
        })
    },
    data(){
        return{
            pagination:[],
            items:[],
            loading:true,
        }
    },
    methods:{
        changePage(page)
        {
          EventBus.$emit('change_page', page);
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
    }
}
</script>

<style lang="scss" scoped>
.loader{
    cursor: progress;
    position:absolute;
    min-height:100vh;
    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    background:rgba(255,255,255,0.7);
    z-index:10;
    img{
        width:100px;
        height:100px;
    }

}
.item{
    width:100%;
    height:100%;
    box-shadow: 0px 8px 24px rgb(55 44 43 / 10%);
    transition:all .2s ease-in-out;
    border-radius:10px;
    position:relative;
    &:hover{
        transform: translateY(-5px);
        box-shadow: 0px 16px 24px rgb(55 44 43 / 25%);
    }
    .infoWrapper{
        position:absolute;
        bottom:0;
        width:100%;
        padding:10px 10px;
        text-align:center;
        font-weight:700;
        color:#fff;
        height:100%;
        background:linear-gradient(
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0.8)
        );
        display:flex;
        align-items: flex-end;
        .infoContent{
            width:100%;
            .itemNumber{
            }
            .itemTitle{

            }
        }
    }
}
.imageWrapper{
    padding-bottom:100%;
    width:100%;
    position:relative;
    .imageInner{
        position:absolute;
        width:100%;
        height:100%;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
img{
    max-width:100%;
    height:auto;
}
.item{
    background:#fff;
}
</style>
